import type { ToggleItem } from '@designSystem/components'
import { objectToToggleItems } from './object'
import { ref } from 'vue'
import { SecteurEntrepriseLibelle, ModeRemunerationLibelle } from '@/features/domaine/types/opco'

export const OuiOuNon = ref<ToggleItem[]>([
  { id: true, label: 'Oui' },
  { id: false, label: 'Non' },
])

export const secteurEntrepriseItems = objectToToggleItems(SecteurEntrepriseLibelle)
export const modeRemunerationItems = objectToToggleItems(ModeRemunerationLibelle)
